import React from "react";
import {
    ArrayInput,
    Datagrid,
    DateField,
    Filter,
    List,
    SelectInput,
    SimpleShowLayout,
    TextField,
    TextInput,
    AutocompleteInput,
    SimpleFormIterator,
    BooleanField,
    BooleanInput, NumberInput, ArrayField,
} from "react-admin";
import ShowView from "../../components/ShowView";
import {
  ConversationFilterProducts,
  ConversationFilterStatus,
  ConversationFilterTags,
  ConversationStatus,
  ConversationInputTags,
  ConversationFilterTypes,
} from "./conversationConstant";
import EditView from "../../components/EditView";
import CreateView from "../../components/CreateView";
import { ConversationType, Products } from "../../constants/choices";

const ConversationFilter = (props) => (
  <Filter {...props}>
    <TextInput label="شناسه" source="objectId" />
    <SelectInput label="حالت" choices={ConversationFilterStatus} optionText={"name"} optionValue={"value"} source={"status"} alwaysOn />
    <SelectInput label="تگ" choices={ConversationFilterTags} optionText={"name"} optionValue={"value"} source={"tag"} alwaysOn />
    <SelectInput label="دسترسی" choices={ConversationFilterTypes} optionText={"name"} optionValue={"value"} source={"type"} alwaysOn />
    <SelectInput label="محصول" choices={ConversationFilterProducts} optionText={"name"} optionValue={"value"} source={"products"} alwaysOn />
    <BooleanInput label="حذف شده؟" source="isDeleted" />
    <TextInput label="عنوان" source="title" />
    <TextInput label="توضیحات" source="description" />
    <NumberInput label="امتیاز" source="rate" />
  </Filter>
);

export const ConversationList = (props) => (
  <List {...props} filters={<ConversationFilter />}>
    <Datagrid rowClick="show">
      <TextField source="objectId" />
      <TextField source="conversationStatusName" />
      <TextField source="type" />
      <TextField source="products" />
      <BooleanField source="isDeleted" />
      <TextField source="title" />
      <TextField source="tag" />
      <TextField source="rate" />
      <TextField source="messageCount" />
      <DateField showTime={true} locales={"fa-IR"} source="lastMessageDate" />
      <DateField showTime={true} locales={"fa-IR"} source="createdAt" />
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt" />
    </Datagrid>
  </List>
);

export const ConversationShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="objectId" />
      <TextField source="conversationStatusName" />
      <TextField source="type" />
        <ArrayField source="adminProducts">
            <Datagrid>
                <TextField source="products" />
            </Datagrid>
        </ArrayField>
      <BooleanField source="isDeleted" />
      <TextField source="title" />
      <TextField source="description" />
        <ArrayField source="adminTag">
            <Datagrid>
                <TextField source="tag" />
            </Datagrid>
        </ArrayField>
      <TextField source="rate" />
      <TextField source="messageCount" />
      <DateField showTime={true} locales={"fa-IR"} source="lastMessageDate" />
      <DateField showTime={true} locales={"fa-IR"} source="createdAt" />
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt" />
    </SimpleShowLayout>
  </ShowView>
);

export const ConversationEdit = (props) => (
  <EditView {...props}>
    <AutocompleteInput source="type" choices={ConversationType} />
    <AutocompleteInput source="status" choices={ConversationStatus} />

    <ArrayInput source="adminProducts">
      <SimpleFormIterator>
        <AutocompleteInput source="products" choices={Products} />
      </SimpleFormIterator>
    </ArrayInput>

    <ArrayInput source="adminTag">
      <SimpleFormIterator>
        <AutocompleteInput source="tag" choices={ConversationInputTags} />
      </SimpleFormIterator>
    </ArrayInput>

    <TextInput source="title" />
    <TextInput source="description" />
  </EditView>
);

export const ConversationCreate = (props) => (
  <CreateView {...props}>
    <AutocompleteInput source="type" choices={ConversationType} />
    <AutocompleteInput source="status" choices={ConversationStatus} />

    <ArrayInput source="adminProducts">
      <SimpleFormIterator>
        <AutocompleteInput source="products" choices={Products} />
      </SimpleFormIterator>
    </ArrayInput>

      <ArrayInput source="adminTag">
          <SimpleFormIterator>
              <AutocompleteInput source="tag" choices={ConversationInputTags} />
          </SimpleFormIterator>
      </ArrayInput>

    <TextInput source="title" />
    <TextInput source="description" />
  </CreateView>
);
